import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Calendar, Star } from 'lucide-react';
export function ProductReveal() {
  const systemItems = [{
    icon: <Clock className="w-6 h-6 text-[#C4704B]" data-id="element-112" />,
    title: '15 minutos',
    desc: 'Te da un mínimo realista. No te exige energía que no tenés.'
  }, {
    icon: <Calendar className="w-6 h-6 text-[#C4704B]" data-id="element-113" />,
    title: '30 días',
    desc: 'Te evita pensar. Vos ejecutás.'
  }, {
    icon: <div className="w-6 h-6 text-[#C4704B]" data-id="element-114" />,
    title: 'Kit Mínimo',
    desc: 'No dependés de compras. No dependés de imprimir.'
  }, {
    icon: <Star className="w-6 h-6 text-[#C4704B]" data-id="element-115" />,
    title: 'Rotación por habilidades',
    desc: "Sentís que 'no estoy haciendo siempre lo mismo' sin planificar."
  }];
  return <section className="py-14 px-6 bg-white relative overflow-hidden" data-id="element-116">
      {/* Decorative background elements */}
      <div className="absolute top-1/4 left-0 w-64 h-64 bg-[#8B9E7E] rounded-full mix-blend-multiply filter blur-3xl opacity-10 -translate-x-1/2" data-id="element-117" />

      <div className="max-w-5xl mx-auto" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-119">
          <span className="text-[#C4704B] font-bold tracking-wider text-sm uppercase mb-2 block" data-id="element-120">
            Presentamos
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-[#2D3A4A] mb-6 font-serif" data-id="element-121">
            Agenda Anti-Pantallas <br data-id="element-122" />
            <span className="text-3xl md:text-5xl font-normal italic text-[#8B9E7E]" data-id="element-123">
              (1–4 años)
            </span>
          </h2>
          <p className="text-xl md:text-2xl text-[#2D3A4A]/80 max-w-3xl mx-auto leading-relaxed" data-id="element-124">
            30 días. 15 minutos por día. Con cosas de tu casa.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-125">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#FFFBF5] p-8 rounded-[2rem] border border-[#F5E6D0]" data-id="element-126">
            <p className="text-lg text-[#2D3A4A] mb-6" data-id="element-127">
              No es un mega pack de 800 hojas para que te sientas culpable por
              no imprimirlo. Es una agenda que te dice:
            </p>
            <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-[#C4704B] italic text-[#2D3A4A] text-lg mb-6" data-id="element-128">
              "Hoy tocaba esto.
              <br data-id="element-129" />
              Preparación: 1 minuto.
              <br data-id="element-130" />
              Duración: 15.
              <br data-id="element-131" />Y listo."
            </div>
            <p className="font-bold text-[#C4704B] text-xl" data-id="element-132">
              Lo que comprás no son actividades. Comprás alivio mental.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-133">
            <h3 className="text-2xl font-bold text-[#2D3A4A] mb-8" data-id="element-134">
              El Sistema 15×30 <br data-id="element-135" />
              <span className="text-base font-normal text-[#2D3A4A]/60" data-id="element-136">
                (el mecanismo que lo vuelve sostenible)
              </span>
            </h3>

            <div className="space-y-4" data-id="element-137">
              {systemItems.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1 * index
            }} className="flex items-start bg-[#F5E6D0]/20 p-4 rounded-xl" data-id="element-138">
                  <div className="bg-[#FFFBF5] p-2 rounded-lg shadow-sm mr-4" data-id="element-139">
                    {item.icon}
                  </div>
                  <div data-id="element-140">
                    <h4 className="font-bold text-[#2D3A4A]" data-id="element-141">{item.title}</h4>
                    <p className="text-[#2D3A4A]/70 text-sm leading-relaxed" data-id="element-142">
                      {item.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}